var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [_vm._v("代采计划列表")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "icon-fresh",
              attrs: { size: "mini", icon: "el-icon-refresh" },
              on: {
                click: function($event) {
                  return _vm.fetchData(true)
                }
              }
            },
            [_vm._v("\n      刷新\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "输入搜索：" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "代采计划单号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.planid,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "planid", $$v)
                                    },
                                    expression: "form.planid"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "商家" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.supply_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "supply_name", $$v)
                                    },
                                    expression: "form.supply_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "市场" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.market_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "market_name", $$v)
                                    },
                                    expression: "form.market_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      multiple: "",
                                      placeholder: "请选择城市"
                                    },
                                    model: {
                                      value: _vm.form.city,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "city", $$v)
                                      },
                                      expression: "form.city"
                                    }
                                  },
                                  _vm._l(_vm.citys, function(item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.selectPgid
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "选择代采组" },
                                        model: {
                                          value: _vm.form.purchase_gid,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "purchase_gid",
                                              $$v
                                            )
                                          },
                                          expression: "form.purchase_gid"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.selectPgid, function(item) {
                                          return _c("el-option", {
                                            key: item.key,
                                            attrs: {
                                              label: item.pgname,
                                              value: item.pgid
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "代采员" },
                                    model: {
                                      value: _vm.form.pg_member_id,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "pg_member_id", $$v)
                                      },
                                      expression: "form.pg_member_id"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.resData.memberOption, function(
                                      item
                                    ) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.planStatus1
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "代采计划状态" },
                                        model: {
                                          value: _vm.form.status,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "status", $$v)
                                          },
                                          expression: "form.status"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "-1" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.planStatus1, function(
                                          item1
                                        ) {
                                          return _c(
                                            "el-option",
                                            {
                                              key: item1.key,
                                              attrs: {
                                                label: item1.label,
                                                value: item1.key
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(item1.label) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "商品货号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.goods_no,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "goods_no", $$v)
                                    },
                                    expression: "form.goods_no"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "生成方式" },
                                        model: {
                                          value: _vm.form.ptype,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "ptype", $$v)
                                          },
                                          expression: "form.ptype"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.resData.optionPtype,
                                          function(item1) {
                                            return _c(
                                              "el-option",
                                              {
                                                key: item1.key,
                                                attrs: {
                                                  label: item1.label,
                                                  value: item1.key
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(item1.label) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "备货单号" },
                                      model: {
                                        value: _vm.form.stocking_id,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "stocking_id", $$v)
                                        },
                                        expression: "form.stocking_id"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "是否小店分发",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.form.is_dispense,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "is_dispense", $$v)
                                      },
                                      expression: "form.is_dispense"
                                    }
                                  },
                                  _vm._l(_vm.public_option, function(item) {
                                    return _c(
                                      "el-option",
                                      {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(item.label) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "代采类型",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.form.plan_type,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "plan_type", $$v)
                                      },
                                      expression: "form.plan_type"
                                    }
                                  },
                                  _vm._l(_vm.purchaseTypeOptions, function(
                                    item
                                  ) {
                                    return _c(
                                      "el-option",
                                      {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(item.label) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { padding: "0 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "生成时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.create_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "create_time", $$v)
                                    },
                                    expression: "form.create_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "完成时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.done_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "done_time", $$v)
                                    },
                                    expression: "form.done_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "需求日期：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.demanded_date,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "demanded_date", $$v)
                                    },
                                    expression: "form.demanded_date"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.search }
                                  },
                                  [_vm._v("查询")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "success" },
                                    on: {
                                      click: function($event) {
                                        return _vm.output(1)
                                      }
                                    }
                                  },
                                  [_vm._v("导出")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _vm.resData
            ? _c(
                "el-col",
                { staticClass: "data-statics", attrs: { span: 24 } },
                [
                  _vm._v(
                    "\n      数据汇总    ：计划代采共" +
                      _vm._s(_vm.resData.plan_num) +
                      "件，计" +
                      _vm._s(_vm.resData.plan_price_total) +
                      "\n    "
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "50px",
                  "line-height": "30px",
                  padding: "0 25px",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [
                _c("div", [_vm._v("数据列表：")]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "auto" },
                    attrs: { size: "mini" },
                    on: {
                      click: function($event) {
                        _vm.showExportDialog = true
                      }
                    }
                  },
                  [_vm._v("\n          导出被阻截生成计划的商品\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "10px" },
                    attrs: { size: "mini" },
                    on: {
                      click: function($event) {
                        return _vm.output(3)
                      }
                    }
                  },
                  [_vm._v("\n          导出代采计划商品\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "10px" },
                    attrs: { type: "success", size: "mini" },
                    on: { click: _vm.createPlan }
                  },
                  [_vm._v("\n          新建手动计划\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "success" },
                    on: { click: _vm.createEarlyPlan }
                  },
                  [_vm._v("\n          新建提前代采计划\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  {
                    staticClass: "item",
                    attrs: { effect: "dark", placement: "top-start" },
                    scopedSlots: _vm._u([
                      {
                        key: "content",
                        fn: function() {
                          return [
                            _c("div", [
                              _c("p", [
                                _vm._v(
                                  "\n                手动计划：待开单数据将融入大盘（出现于代采APP的待开单及爆版APP的一手订货单里）；\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "\n                提前代采计划：待开单数据不融入大盘，需再【代采核单】列表独立开单；\n              "
                                )
                              ])
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ])
                  },
                  [
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "el-icon-warning-outline",
                      staticStyle: {
                        "font-size": "25px",
                        "margin-left": "15px",
                        cursor: "pointer"
                      }
                    })
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-bottom": "0" } },
              [
                _vm.resData.data
                  ? _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.tableLoading,
                            expression: "tableLoading"
                          }
                        ],
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          height: "600",
                          data: _vm.resData.data,
                          "tooltip-effect": "dark"
                        },
                        on: { "selection-change": _vm.handleSelectionChange }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "planid",
                            label: "代采计划编号",
                            width: "120"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { align: "center", label: "生成方式" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    _c("div", [_vm._v(_vm._s(row.ptype_text))]),
                                    _vm._v(" "),
                                    row.is_dispense === "1"
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "font-size": "12px",
                                              color: "blue"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                小店分发\n              "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            812040829
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "market_name",
                            label: "市场"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "supply_floor",
                            label: "楼层"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "supply_area",
                            label: "区域"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "supply_name",
                            label: "商家",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { prop: "supply_city", label: "城市" }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "m_name",
                            label: "代采员",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "pgname",
                            label: "代采组",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "plan_price_total",
                            label: "计划代采金额",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "plan_num",
                            label: "计划代采",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "wait_order_num",
                            label: "待开单",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "wait_cancel_num",
                            label: "急救箱",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "cancel_num",
                            label: "已断货",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "finance_wait_confirm_num",
                            label: "财务待审核",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "ok_num",
                            label: "已完成",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "ok_price_total",
                            label: "已完成金额",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "create_time",
                            label: "生成时间",
                            width: "100",
                            sortable: "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "wp_check_time",
                            label: "审核时间",
                            width: "100",
                            sortable: "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "wp_demanded_date",
                            width: "120",
                            sortable: "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function() {
                                  return [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          placement: "top"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              position: "relative",
                                              display: "inline-block"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  需求日期"
                                            ),
                                            _c("i", {
                                              staticClass: "el-icon-info"
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content"
                                          },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                "需求日期是用于考核商家履约的起始时间"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                "①系统/重采计划：需求日期=当天"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                "\n                    ②买版/提前代采计划：不融入爆版订货单，不考核，需要日期为空。\n                  "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                "\n                    ③其他计划：免审时为生成时间的次日；需审时，为审核时间的次日\n                  "
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            3381233870
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "done_time_text",
                            label: "完成时间",
                            width: "100",
                            sortable: "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "status_text",
                            label: "状态",
                            width: "100",
                            sortable: "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "操作",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "200"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "small" },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleDetail(scope.row)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                查看\n              "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    scope.row.status == 11
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "small"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.handleWithdraw(
                                                  scope.row
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                撤销\n              "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "small" },
                                        on: {
                                          click: function($event) {
                                            return _vm.copy(scope.row)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                H5链接\n              "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            4255503340
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.resData.data
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.curPage,
                        background: "",
                        layout: "total, prev, pager, next, jumper ",
                        total: _vm.resData.total,
                        "page-size": 10
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.curPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.curPage = $event
                        },
                        "current-change": _vm.handleCurrentChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticStyle: { "text-align": "center" },
          attrs: {
            visible: _vm.showExportDialog,
            title: "导出被阻截生成计划的商品"
          },
          on: {
            "update:visible": function($event) {
              _vm.showExportDialog = $event
            }
          }
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "auto" },
              on: {
                click: function($event) {
                  return _vm.exportPlanHoldUp(_vm.planType.FORECAST_PLAN)
                }
              }
            },
            [_vm._v("\n      提前预测被拦截\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "20px" },
              on: {
                click: function($event) {
                  return _vm.exportPlanHoldUp(_vm.planType.SYSTEM_PLAN)
                }
              }
            },
            [_vm._v("\n      系统计划被拦截\n    ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b396d7a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b396d7a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PurchasePlanList.vue
// module id = null
// module chunks = 